import { Component, effect, inject } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { Meal } from 'src/app/trip-calculator/models/meal';
import { PrestationModalService } from 'src/app/trip-calculator/services/prestation-modal.service';
import { PrestationEmptyStateComponent } from '../prestation-empty-state/prestation-empty-state.component';
import { TripService } from 'src/app/trip-calculator/services/trip.service';
import { PopoverModule } from 'primeng/popover';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SectionValidationService } from '../../../services/section-validation.service';
import { ItemValidationBadgeComponent } from '../../item-validation-badge/item-validation-badge.component';
import { DecimalToPercentPipe } from 'src/app/pipes/decimal-to-percent.pipe';

@Component({
  selector: 'app-meal-section',
  imports: [
    ButtonModule,
    TranslocoPipe,
    PrestationEmptyStateComponent,
    PopoverModule,
    ConfirmDialogModule,
    ItemValidationBadgeComponent,
    DecimalToPercentPipe,
  ],
  templateUrl: './meal-section.component.html',
})
export class MealSectionComponent {
  tripService = inject(TripService);
  prestationModalService = inject(PrestationModalService);
  translocoService = inject(TranslocoService);
  confirmationService = inject(ConfirmationService);
  sectionValidationService = inject(SectionValidationService);
  meals?: Meal[];
  hasMeal: boolean = false;

  constructor() {
    effect(() => {
      const trip = this.tripService.trip();
      if (trip) {
        this.meals = trip.meals;
        this.hasMeal = trip.meals.length > 0;
      }
    });
  }
  addMeal = () => {
    this.prestationModalService.addMeal();
  };
  editMeal(index: number) {
    this.prestationModalService.editMeal(index);
  }
  deleteMeal(index: number) {
    this.tripService.deleteMeal(index)?.subscribe();
  }
  confirmDelete(index: number) {
    const message = this.translocoService.translate('confirmation.deleteMeal');
    const header = this.translocoService.translate(
      'confirmation.deleteConfirmation',
    );
    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translocoService.translate('yes'),
      rejectLabel: this.translocoService.translate('no'),
      accept: () => this.deleteMeal(index),
    });
  }

  onValidationBadgeClick() {
    // Get the first issue to navigate to the right meal
    const issues = this.sectionValidationService.getIssuesForSection('meal');
    const firstErrorIssue = issues.find((issue) => issue.severity === 'error');
    const firstIssue = firstErrorIssue || issues[0];

    if (firstIssue?.index !== undefined) {
      this.prestationModalService.editMeal(firstIssue.index);
    } else {
      this.prestationModalService.addMeal();
    }
  }

  onItemValidationBadgeClick(event: {
    scope: 'transport' | 'accommodation' | 'activity' | 'meal';
    index: number;
  }) {
    if (event.scope === 'meal') {
      this.prestationModalService.editMeal(event.index);
    }
  }
}
